<template>
  <v-card elevation="0" flat>
    <v-card-title>
      <span>{{entityName}}</span>
    </v-card-title>
    <v-card-text>
      <v-row class="pa-4" justify="space-between">
        <v-col cols="12">
          <v-btn @click="onNewClick()" color="primary">New</v-btn>
        </v-col>
        <v-col cols="12" :md="leftPanelWidth">        
          <v-scroll-y-transition mode="out-in">
            <div v-if="!selected && !newEntry" class="title grey--text text--lighten-1 text-center">
              Select an item
            </div>
            <v-card v-else outlined
              :key="selected ? selected.uuid : '1'"
              >
              <v-card-text>
                <slot name="entryForm" 
                  v-bind:selectedItem="selected" 
                  v-bind:onSaveItem="onSaveItem"
                  v-bind:onDeleteItem="onDeleteItem">
                </slot>
              </v-card-text>
            </v-card>
          </v-scroll-y-transition>
        </v-col> 
        <v-divider vertical v-if="!$vuetify.breakpoint.mobile"></v-divider>
        <v-col cols="12" :md="(11-leftPanelWidth)" class="d-flex flex-row">
          <slot name="itemListing" 
            v-bind:onItemSelected="onSelect"
            v-bind:values="itemValues"
            v-bind:displayText="itemText"
            >
          </slot>
        </v-col>
      </v-row>
      <confirmation-dialog 
        alertType="error"
        dialogType="confirm"
        title="Confirmation"
        :select="confirmDialog.select"
        :message="confirmDialog.message"
        :show="confirmDialog.show"
        :object="confirmDialog.object"
        @onOk="confirmDialog.onOk"
        @onCancel="confirmDialog.onCancel"/>
      <confirmation-dialog 
        dialogType="info"
        :alertType="infoDialog.type"
        :title="infoDialog.title"
        :message="infoDialog.message"
        :show.sync="infoDialog.show"/>  
    </v-card-text>
  </v-card>
</template>

<script>
import { ReplyCode } from "@/model";
import ConfirmationDialog from '../common/ConfirmationDialog.vue';

export default {
  name: "GenericConfig",
  components: {
    ConfirmationDialog,
  },
  props: {
    values: {
      type: Function,
      default: () => ([])
    },
    displayText: {
      type: String,
      default: "",
    },
    onSaveHandler: {
      type: Function,
      default: () => {}
    },
    onDeleteHandler: {
      type: Function,
      default: () => {}
    },
    entityName: {
      type: String,
      default: "Item"
    },
    leftPanelWidth: {
      type: Number,
      default: 4
    }
  },
  created() {
  },
  data: () => ({
    selected: undefined,
    newEntry: false,
    editForm : {show: false, newEntry : false},
    confirmDialog: {show: false, message: "", select: {}, onOk: () => {}, onCancel: () => {}},
    infoDialog: {type: "info", title: "", message: "", show: false }
  }),
  computed: {
    itemValues() {
      return this.values ? this.values() : [];
    },
    itemText() {
      return this.displayText ? this.displayText : "";
    }
  },
  methods: {
    onSelect(item) {
      this.selected = item;
      window.selected = this.selected;
      this.newEntry = false;
    },
    resetSelection() {
      this.selected = undefined;
      this.newEntry = false;
    },
    hasChildren(item) {
      return item.children.length > 0
    },
    onNewClick() {
      this.selected = undefined;
      this.newEntry = true;
    },
    async onSaveItem(valueObject) {
      try {
        await this.onSaveHandler(valueObject);
        this.$root.$emit("Notification", `${this.entityName} saved`);
        this.resetSelection();
      } catch (reply) {
        this.showError(reply.message);
      }
    },
    onDeleteItem(valueObject) {
      this.selected = valueObject;
      this.showDeleteConfirm("Delete Confirm?")
    },
    showError(message) {
      this.showInfo(message, "error");
    },
    showInfo(message, type) {
      this.infoDialog = {
        type: type ? type : "info", 
        title: "", 
        message: message, 
        show: true, 
      }
    },
    showDeleteConfirm(msg) {
      this.confirmDialog.message = msg; 
      this.confirmDialog.show = true;
      this.confirmDialog.object = this.selected;
      this.confirmDialog.onOk = this.onDeleteConfirm;
      this.confirmDialog.onCancel = () => { this.confirmDialog.show = false; };
    },
    hideDeleteConfirm() {
      this.confirmDialog.message = ""; 
      this.confirmDialog.object = undefined;
      this.confirmDialog.show = false;
      this.confirmDialog.select = {};
    },
    async onDeleteConfirm(retObject) {
      if (retObject) {
        try {
          await this.onDeleteHandler([retObject.object, retObject.select]);
          this.hideDeleteConfirm();
          this.showInfo(`${this.entityName} deleted`);
          this.resetSelection();
        } catch (reply) {
          this.onDeleteFailed(retObject, reply);
        }
      }
      else {
        this.hideDeleteConfirm();
        this.showError("Something went wrong.");
      }
    },
    onDeleteFailed(retObject, reply) {
      console.error(reply);
      if (reply.code === ReplyCode.DELETE_FAILED_DATA_DEPENDENCY) {
        const toDeleteItem = retObject.object;
        this.confirmDialog.select = {
          values: this.values(toDeleteItem),
          label: `Replacement ${this.entityName}`,
          text: this.itemText,
          required: true
        }
        this.showDeleteConfirm(reply.message);
        return;
      }
      const msg = reply.code === ReplyCode.UNKNOWN ? "Delete failed" : reply.message;
      this.hideDeleteConfirm();
      this.showError(msg);
    },
    onDeleteCancel() {
      this.hideDeleteConfirm()
    },
  },
};
</script>